import '.kc{display:inline-block;}.ssr-plugin'
import '.i9{margin-top:1.5rem;}.ssr-plugin'
import '.b8{font-size:0.875rem;}.ssr-plugin'
import '.kd{color:var(--palette-blue-500);}.ssr-plugin'
import '.is{text-decoration:underline;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { styled } from 'inlines'

export type DiscoveryCrawlerPaginationFooterProps = {
  nextPageHref: string | null
}

export const DiscoveryCrawlerPaginationFooter = ({
  nextPageHref,
}: DiscoveryCrawlerPaginationFooterProps) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!nextPageHref || mounted) {
    return null
  }

  return (
    <a className="kc i9 b8 kd is"
      rel="next"
      href={nextPageHref}
    >
      next page
    </a>
  )
}
